/* CMS 數據List */
import { Fragment, useRef } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import {
  Backdrop,
  Box,
  Divider,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Stack, Tooltip,
  Typography,
  Skeleton,
} from '@mui/material';
import SimPagination from '../pagination';
import { TypographyCheck, TypographyLink } from '../hovers';
import { NoData } from '../error';
import { LoadingScreen } from '../loading-screen';
import { fDate } from '../../utils/formatTime';
import Label from '../label';
import TagItem from '../TagItem';
import FileIcon from '../file/FileIcon';


// ================================|| Primary List Item ||================================ //
const PriamryItem = ({ theme, item = {}, onClick }) => {
  const { sender, title, publishDate } = item || {}
  return (
    <ListItem
      alignItems="center"
      disablePadding
      sx={{ ...theme.typography.hoverPrimaryLeftline2px }}>
      <ListItemButton
        onClick={onClick}
        sx={{
          py: 2,
          px: 1.5,
          '&.Mui-focusVisible': {
            backgroundColor: 'transparent',
          },
          '& .MuiListItemText-root': {
            m: 0,
            position: 'relative',
            overflow: 'hidden'
          },
          '& .Sim-more': {
            display: 'flex',
            alignItems: 'center',
            whiteSpace: 'nowrap',
            opacity: 0,
            visibility: 'hidden',
            pl: 3,
            transition: 'all 0.3s 0s ease-out',
          },
          '&:hover': {
            backgroundColor: theme => theme.palette.action.hover,
            '& .Sim-more': {
              opacity: 1,
              visibility: 'visible',
              animation: 'fadeInRight .3s forwards',
            }
          }
        }}
      >
        <ListItemText
          disableTypography
          sx={{ overflow: 'visible !important' }}
          primary={
            <Box component={'span'} display={'flex'} alignItems={'center'} mb={1}>
              <Typography
                mr={0.5}
                display={'block'}
                component="span"
                variant="h6"
                color="grey.800"
                noWrap
              >
                {title}
              </Typography>
            </Box>
          }
          secondary={
            <>
              {/* <Tooltip
                placement="bottom-start"
                title={
                  <Typography variant={'body2'} onClick={(event) => {
                    event.stopPropagation();
                    event.preventDefault();}
                  }>
                    {title}
                  </Typography>
                }
                PopperProps={{
                  sx: {
                    borderRadius: 6/9,
                  },
                }}
                slotProps={{
                  popper: {
                    sx: {
                      zIndex: 1
                    },
                  },
                  tooltip: {
                    sx: {},
                  }
                }}
              >
                <Typography
                  component="span"
                  variant={'body1'}
                  color={'text.secondary'}
                  display={'block'}
                  mb={1}
                  noWrap
                >
                  {publishDate}
                </Typography>
              </Tooltip> */}
              <Typography
                component="span"
                variant={'body1'}
                color={'text.secondary'}
                display={'block'}
                noWrap
              >
                {publishDate && fDate(publishDate, 'yyyy/MM/dd')}
              </Typography>
              {sender && (<TagItem label={sender} />)}
            </>
          }
        />
        <Box className={'Sim-more'}>
          <TypographyLink className={'Sim-icon-link'} primary={'查看'} bgColor={'transparent'} textColor={'#489CFF'} iconColor={'#489CFF'} disableBoxShadow />
        </Box>
      </ListItemButton>
    </ListItem>
  )
};

// ================================|| Secondary List Item ||================================ //
const SecondaryItem = ({ item = {}, onClick }) => {
  const theme = useTheme();

  const { publishDate, title } = item || {}
  return (
    <ListItem
      alignItems="center"
      disablePadding
      sx={{ ...theme.typography.hoverPrimaryLeftline2px }}
    >
      <ListItemButton
        onClick={onClick}
        sx={{
          py: 2,
          px: 1.5,
          '&.Mui-focusVisible': {
            backgroundColor: 'transparent',
          },
          '& .MuiListItemText-root': {
            m: 0,
            position: 'relative',
            overflow: 'hidden'
          },
          '& .Sim-more': {
            display: 'flex',
            alignItems: 'center',
            whiteSpace: 'nowrap',
            opacity: 0,
            visibility: 'hidden',
            pl: 3,
            transition: 'all 0.3s 0s ease-out',
          },
          '&:hover': {
            backgroundColor: theme => theme.palette.action.hover,
            '& .Sim-more': {
              opacity: 1,
              visibility: 'visible',
            }
          }
        }}
      >
        <ListItemText
          disableTypography
          sx={{ overflow: 'visible !important' }}
          primary={
            <Box component={'span'} display={'flex'} alignItems={'center'} gap={2}>
              <Typography
                display={'block'}
                component="span"
                variant="h6"
                fontWeight={400}
                color="text.secondary"
                noWrap
              >
                { publishDate }
              </Typography>
              <Typography
                mr={0.5}
                display={'block'}
                component="span"
                variant="h6"
                color="text.primary"
                noWrap
              >
                { title }
              </Typography>
            </Box>
          }
        />
        <Box className={'Sim-more'}>
          <TypographyLink bgColor={'transparent'} iconColor={theme.palette.error.main} disableBoxShadow />
        </Box>
      </ListItemButton>
    </ListItem>
  )
};

// ================================|| Tertiary List Item ||================================ //
const TertiaryItem = ({ item = {}, onClick }) => {
  const theme = useTheme();
  const { title, publishDate, detailsDto } = item || {};
  const { author } = detailsDto || {};

  return (
    <ListItem
      alignItems="center"
      disablePadding
      sx={{ ...theme.typography.hoverPrimaryLeftline2px }}
    >
      <ListItemButton
        onClick={onClick}
        sx={{
          py: 2,
          px: 1.5,
          '&.Mui-focusVisible': {
            backgroundColor: 'transparent',
          },
          '& .MuiListItemText-root': {
            m: 0,
            position: 'relative',
            overflow: 'hidden'
          },
          '& .Sim-more': {
            display: 'flex',
            alignItems: 'center',
            whiteSpace: 'nowrap',
            opacity: 0,
            visibility: 'hidden',
            pl: 3,
            transition: 'all 0.3s 0s ease-out',
          },
          '&:hover': {
            backgroundColor: theme => theme.palette.action.hover,
            '& .Sim-more': {
              opacity: 1,
              visibility: 'visible',
            }
          }
        }}
      >
        <ListItemText
          disableTypography
          sx={{ overflow: 'visible !important' }}
          primary={
            <Typography
              display={'block'}
              component="span"
              variant="h6"
              fontWeight={400}
              color="text.primary"
              mb={0.5}
              noWrap
            >
              { title }
            </Typography>
          }
          secondary={
            <Box display={'flex'}>
              <Typography
                component="span"
                variant={'body1'}
                color={'text.secondary'}
              >
                { publishDate && fDate(publishDate, 'yyyy-MM-dd')}
              </Typography>
              {author && (<Divider sx={{ width: 4, height: 4, alignSelf: 'center', mx: 1, border: 'none' }} color={'error.main'} orientation="vertical" variant="middle" flexItem />)}
              <Typography
                component="span"
                variant={'body1'}
                color={'text.secondary'}
              >
                { author }
              </Typography>
            </Box>
          }
        />
        <Box className={'Sim-more'}>
          <TypographyLink bgColor={'transparent'} iconColor={theme.palette.error.main} disableBoxShadow />
        </Box>
      </ListItemButton>
    </ListItem>
  )
};

// ================================|| Quaternary List Item ||================================ //
const QuaternaryItem = ({ theme, item = {}, onClick }) => {
  const { title, contentType, publishDate, detailsDto } = item || {};
  const { author, imageList } = detailsDto || {};
  const [file, ...others] = imageList || [];
  return (
    <ListItem
      alignItems="center"
      disablePadding
      sx={{ ...theme.typography.hoverPrimaryLeftline2px }}
    >
      <ListItemButton
        onClick={onClick}
        sx={{
          py: 2,
          px: 1.5,
          '&.Mui-focusVisible': {
            backgroundColor: 'transparent',
          },
          '& .MuiListItemText-root': {
            m: 0,
            position: 'relative',
            overflow: 'hidden'
          },
          '& .Sim-more': {
            display: 'flex',
            alignItems: 'center',
            whiteSpace: 'nowrap',
            opacity: 0,
            visibility: 'hidden',
            pl: 3,
            transition: 'all 0.3s 0s ease-out',
          },
          '&:hover': {
            backgroundColor: theme => theme.palette.action.hover,
            '& .Sim-more': {
              opacity: 1,
              visibility: 'visible',
            }
          }
        }}
      >
        <ListItemText
          disableTypography
          sx={{ overflow: 'visible !important' }}
          primary={
            <Box display={'flex'} alignItems="center" gap={1} mb={0.5}>
              <FileIcon type={file?.imageType} />
              <Typography
                display={'block'}
                component="span"
                variant="h6"
                color="text.primary"
                noWrap
              >
                { title }
              </Typography>
            </Box>
          }
          secondary={
            <Box>
              <Typography variant={'h6'} fontWeight={400} color={'text.secondary'} mb={0.5}>
                { file?.description || title }
              </Typography>
              <Box display={'flex'} alignItems={'center'}>
                <Typography
                  component="span"
                  variant={'body2'}
                  color={'text.secondary'}
                >
                  { publishDate && fDate(publishDate, 'yyyy-MM-dd')}
                </Typography>
                {author && (<Divider sx={{ width: 4, height: 4, alignSelf: 'center', mx: 1, border: 'none' }} color={'error.main'} orientation="vertical" variant="middle" flexItem />)}
                <Typography
                  component="span"
                  variant={'body2'}
                  color={'text.secondary'}
                >
                  { author }
                </Typography>
              </Box>
            </Box>
          }
        />
        <Box className={'Sim-more'}>
          <TypographyCheck primary={'下載'} />
        </Box>
      </ListItemButton>
    </ListItem>
  )
  // return _.map(imageList, file => {
  //   return (
  //     <ListItem
  //       alignItems="center"
  //       disablePadding
  //       sx={{ ...theme.typography.hoverPrimaryLeftline2px }}
  //     >
  //       <ListItemButton
  //         onClick={onClick}
  //         sx={{
  //           py: 2,
  //           px: 1.5,
  //           '&.Mui-focusVisible': {
  //             backgroundColor: 'transparent',
  //           },
  //           '& .MuiListItemText-root': {
  //             m: 0,
  //             position: 'relative',
  //             overflow: 'hidden'
  //           },
  //           '& .Sim-more': {
  //             display: 'flex',
  //             alignItems: 'center',
  //             whiteSpace: 'nowrap',
  //             opacity: 0,
  //             visibility: 'hidden',
  //             pl: 3,
  //             transition: 'all 0.3s 0s ease-out',
  //           },
  //           '&:hover': {
  //             backgroundColor: theme => theme.palette.action.hover,
  //             '& .Sim-more': {
  //               opacity: 1,
  //               visibility: 'visible',
  //             }
  //           }
  //         }}
  //       >
  //         <ListItemText
  //           disableTypography
  //           sx={{ overflow: 'visible !important' }}
  //           primary={
  //             <Box display={'flex'} alignItems="center" gap={1} mb={0.5}>
  //               <FileIcon type={file?.imageType} />
  //               <Typography
  //                 display={'block'}
  //                 component="span"
  //                 variant="h6"
  //                 color="text.primary"
  //                 noWrap
  //               >
  //                 { title }
  //               </Typography>
  //             </Box>
  //           }
  //           secondary={
  //             <Box>
  //               <Typography variant={'h6'} fontWeight={400} color={'text.secondary'} mb={0.5}>
  //                 { file?.description || title }
  //               </Typography>
  //               <Box display={'flex'} alignItems={'center'}>
  //                 <Typography
  //                   component="span"
  //                   variant={'body2'}
  //                   color={'text.secondary'}
  //                 >
  //                   { publishDate && fDate(publishDate, 'yyyy-MM-dd')}
  //                 </Typography>
  //                 {author && (<Divider sx={{ width: 4, height: 4, alignSelf: 'center', mx: 1, border: 'none' }} color={'error.main'} orientation="vertical" variant="middle" flexItem />)}
  //                 <Typography
  //                   component="span"
  //                   variant={'body2'}
  //                   color={'text.secondary'}
  //                 >
  //                   { author }
  //                 </Typography>
  //               </Box>
  //             </Box>
  //           }
  //         />
  //         <Box className={'Sim-more'}>
  //           <TypographyCheck primary={'下載'} />
  //         </Box>
  //       </ListItemButton>
  //     </ListItem>
  //   )
  // })
};

// ================================|| Download List Item ||================================ //
const DownloadItem = ({ theme, item = {}, onClick }) => {
  const { title, contentType, sender, publishDate, detailsDto } = item || {};
  const { author, imageList } = detailsDto || {};
  const [file, ...others] = imageList || [];
  return (
    <ListItem
      alignItems="center"
      disablePadding
      sx={{ ...theme.typography.hoverPrimaryLeftline2px }}>
      <ListItemButton
        onClick={onClick}
        sx={{
          py: 2,
          px: 1.5,
          '&.Mui-focusVisible': {
            backgroundColor: 'transparent',
          },
          '& .MuiListItemText-root': {
            m: 0,
            position: 'relative',
            overflow: 'hidden'
          },
          '& .Sim-more': {
            display: 'flex',
            alignItems: 'center',
            whiteSpace: 'nowrap',
            opacity: 0,
            visibility: 'hidden',
            pl: 3,
            transition: 'all 0.3s 0s ease-out',
          },
          '&:hover': {
            backgroundColor: theme => theme.palette.action.hover,
            '& .Sim-more': {
              opacity: 1,
              visibility: 'visible',
              animation: 'fadeInDown .3s forwards',
            }
          }
        }}
      >
        <ListItemText
          disableTypography
          sx={{ overflow: 'visible !important' }}
          primary={
            <Box component={'span'} display={'flex'} alignItems={'center'} mb={1}>
              <Typography
                mr={0.5}
                display={'block'}
                component="span"
                variant="h6"
                color="grey.800"
                noWrap
              >
                {title}
              </Typography>
            </Box>
          }
          secondary={
            <Stack direction={'row'} alignItems={'center'} maxHeight={20}>
              <Typography
                component="span"
                variant={'body2'}
                color={'text.secondary'}
                noWrap
              >
                { publishDate && fDate(publishDate, 'yyyy/MM/dd')}
              </Typography>
              <Typography mx={0.5} display={'flex'}>
                <FileIcon type={file?.imageType} color={theme.palette.error.main} />
              </Typography>
              <Typography variant={'body2'} color={'text.secondary'}>
                {/* Math.floor(num * 10) / 10 */}
                {/* Math.round((Number(file?.fileSize) / 1024) * 10) / 10 */}
                {file?.fileSize ? (Math.floor((Number(file?.fileSize) / 1024) * 10) / 10) : 0}KB
              </Typography>
              {sender && (<TagItem label={sender} />)}
              {sender && (<TagItem label={sender} />)}
            </Stack>
          }
        />
        <Box className={'Sim-more'}>
          <TypographyCheck primary={'下載'} color={'#489CFF'} iconColor={'#489CFF'} />
        </Box>
      </ListItemButton>
    </ListItem>
  )
};


// ================================|| Notification List Item ||================================ //
const NotificationItem = ({ theme, item = {}, onClick }) => {
  const { sender, title, publishDate } = item || {}
  return (
    <ListItem
      alignItems="center"
      disablePadding
      sx={{ ...theme.typography.hoverPrimaryLeftline2px }}>
      <ListItemButton
        onClick={onClick}
        sx={{
          py: 2,
          px: 1.5,
          '&.Mui-focusVisible': {
            backgroundColor: 'transparent',
          },
          '& .MuiListItemText-root': {
            m: 0,
            position: 'relative',
            overflow: 'hidden'
          },
          '& .Sim-more': {
            display: 'flex',
            alignItems: 'center',
            whiteSpace: 'nowrap',
            opacity: 0,
            visibility: 'hidden',
            pl: 3,
            transition: 'all 0.3s 0s ease-out',
          },
          '&:hover': {
            backgroundColor: theme => theme.palette.action.hover,
            '& .Sim-more': {
              opacity: 1,
              visibility: 'visible',
              animation: 'fadeInRight .3s forwards',
            }
          }
        }}
      >
        <ListItemText
          disableTypography
          sx={{ overflow: 'visible !important' }}
          primary={
            <Box component={'span'} display={'flex'} alignItems={'center'} gap={1} mb={1}>
              <Divider sx={{ width: 6, height: 6, alignSelf: 'center', border: 'none', borderRadius: 99 }} color={'error.main'} orientation="vertical" variant="middle" flexItem />
              <Typography
                mr={0.5}
                display={'block'}
                component="span"
                variant="h6"
                color="grey.800"
                noWrap
              >
                {title}
              </Typography>
            </Box>
          }
          secondary={
            <>
              <Typography
                component="span"
                variant={'body1'}
                color={'text.secondary'}
                display={'block'}
                noWrap
              >
                {publishDate && fDate(publishDate, 'yyyy/MM/dd')}
              </Typography>
              {sender && (<TagItem label={sender} />)}
            </>
          }
        />
        <Box className={'Sim-more'}>
          <TypographyLink className={'Sim-icon-link'} primary={''} bgColor={'transparent'} textColor={'#489CFF'} iconColor={'#489CFF'} disableBoxShadow />
        </Box>
      </ListItemButton>
    </ListItem>
  )
};

// ================================|| FeedbackItem List Item ||================================ //
const FeedbackItem = ({ theme, item = {}, onClick }) => {
  const { sender, title, publishDate } = item || {}
  return (
    <ListItem
      disablePadding
      sx={{ ...theme.typography.hoverPrimaryLeftline2px }}>
      <ListItemButton
        onClick={onClick}
        sx={{
          py: 2,
          px: 1.5,
          '&.Mui-focusVisible': {
            backgroundColor: 'transparent',
          },
          '& .MuiListItemText-root': {
            m: 0,
            position: 'relative',
            overflow: 'hidden'
          },
          '& .Sim-more': {
            display: 'flex',
            alignItems: 'center',
            whiteSpace: 'nowrap',
            opacity: 0,
            visibility: 'hidden',
            pl: 3,
            transition: 'all 0.3s 0s ease-out',
          },
          '&:hover': {
            backgroundColor: theme => theme.palette.action.hover,
            '& .Sim-more': {
              opacity: 1,
              visibility: 'visible',
              animation: 'fadeInRight .3s forwards',
            }
          }
        }}
      >
        <ListItemText
          disableTypography
          sx={{ overflow: 'visible !important' }}
          primary={
            <Box component={'span'} display={'flex'} alignItems={'center'} gap={1} mb={1}>
              <Divider sx={{ width: 6, height: 6, alignSelf: 'center', border: 'none', borderRadius: 99 }} color={'error.main'} orientation="vertical" variant="middle" flexItem />
              <Typography
                mr={0.5}
                display={'block'}
                component="span"
                variant="h6"
                color="grey.800"
                noWrap
              >
                {title}
              </Typography>
            </Box>
          }
          secondary={
            <>
              <Typography
                component="span"
                variant={'body1'}
                color={'text.secondary'}
                display={'block'}
                noWrap
              >
                {publishDate && fDate(publishDate, 'yyyy/MM/dd')}
              </Typography>
              {sender && (<TagItem label={sender} />)}
            </>
          }
        />
        <Box className={'Sim-more'}>
          <TypographyLink className={'Sim-icon-link'} primary={''} bgColor={'transparent'} textColor={'#489CFF'} iconColor={'#489CFF'} disableBoxShadow />
        </Box>
      </ListItemButton>
    </ListItem>
  )
};

// ================================|| Service List ||================================ //
const SimBasicList = ({
  disableScrollTop = false,
  variant = 'primary',
  list = [],
  page = 1,
  defaultPage = 1,
  rowsPerPage = 10,
  total = 0,
  count = 0,
  onChangePage,
  onChangeRowsPerPage,
  onLink,
  loading = false,
  itemMinHeight = 72,
  disabledRowsEmpty = false,
  hideHeader = false,
  filterTools
})=> {
  const listRef = useRef(null);
  const theme = useTheme();

  const row = (item) => {
    return {
      primary:      <PriamryItem theme={theme} item={item} onClick={(event) => onLink(event, item)}  />,
      secondary:    <SecondaryItem theme={theme} item={item} onClick={(event) => onLink(event, item)}  />,
      tertiary:     <TertiaryItem theme={theme} item={item} onClick={(event) => onLink(event, item)} />,
      quaternary:   <QuaternaryItem theme={theme} item={item} onClick={(event) => onLink(event, item)} />,
      download:     <DownloadItem theme={theme} item={item} onClick={(event) => onLink(event, item)}  />,
      notification: <NotificationItem theme={theme} item={item} onClick={(event) => onLink(event, item)}  />,
      feedback:     <FeedbackItem theme={theme} item={item} onClick={(event) => onLink(event, item)}  />,
    }
  };

  // 页码跳转
  const onQuickJumper = async (event) => {
    if(event?.target?.value && Number(event?.target?.value) > 0 && Number(event?.target?.value) <= Number(count)) {
      await onChangePage(event, Number(event.target.value));
    }
    if(event?.target?.value && Number(event?.target?.value) > 0 && Number(event?.target?.value) > Number(count)) {
      await onChangePage(event, Number(count));
    }
  };

  const emptyRows = list?.length < Number(rowsPerPage) ? Math.floor(10 - list?.length) : 0;

  return (
    <Stack spacing={3}>
      {
        (!hideHeader) && (
          <Stack direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
            <Typography variant='h6' minHeight={40} display={'flex'} alignItems={'center'}>
              共&nbsp;
              <Typography variant='h6' color={theme.palette.action.selected} component={'span'}>{total}</Typography> 
              &nbsp;筆相關資料
            </Typography>
            {filterTools}
          </Stack>
        )
      }

      <Stack>
        <Box 
          ref={listRef} 
          position={'relative'} 
          overflow={'hidden'}
          // minHeight={emptyRows > 0 && (!disabledRowsEmpty) ? itemMinHeight * Number(rowsPerPage) : 50} 
          minHeight={(((listRef.current?.scrollHeight) / Number(rowsPerPage)) * Number(list?.length)) > 120 ? (((listRef.current?.scrollHeight) / Number(rowsPerPage)) * Number(list?.length)) : 120}
          sx={{
            // minHeight: `${itemMinHeight * Number(list?.length) > 300 ? itemMinHeight * Number(list?.length) : 300}px`,
            // minHeight: emptyRows > 0 && (!disabledRowsEmpty) ? `${listRef.current?.scrollHeight}px` : 50,
            // minHeight: `${((listRef.current?.scrollHeight) / Number(rowsPerPage)) * Number(list?.length)}`,
            transition: 'all 0.26s linear',
            transformOrigin: 'top',
          }}
        >
          <Backdrop
            sx={{
              position: 'absolute',
              textAlign: 'center',
              height: '100%',
              zIndex: theme.zIndex.drawer + 1,
              backgroundColor: 'transparent'
            }}
            open={Boolean(loading)}
          >
            <LoadingScreen sx={{ alignItems: 'flex-start', minHeight: 'auto' }} />
          </Backdrop>
          {/* <Box position={'absolute'} top={0}>
            {`${((listRef.current?.scrollHeight) / Number(rowsPerPage)) * Number(list?.length)}px`}
          </Box> */}
          {
            total > 0 ? (
              <List disablePadding>
                {
                  _.map(list, (item, index) => {
                    return (
                      <Fragment key={index}>
                        {row(item)[variant]}
                        <Divider component="li" sx={{ mt: -0.125 }} />
                      </Fragment>
                    )
                  })
                }
                {emptyRows > 0 && (!disabledRowsEmpty) && (
                  <ListItem style={{ height: ((listRef.current?.scrollHeight) / Number(rowsPerPage)) * emptyRows }} />
                )}
              </List>
            ) : (
              loading ? (
                _.map(Array.from({ length: Number(rowsPerPage) }), (item, index) => {
                  return (
                    <Box key={index} sx={{ mb: 0.5 }}>
                      {/* <Skeleton variant="rectangular" width={`100%`} height={itemMinHeight} /> */}
                    </Box>)
                })
              ) : (
                <NoData minHeight={300} />
              )
            )
          }
        </Box>
        <SimPagination
          disableScrollTop={disableScrollTop}
          total={Number(total)}
          page={Number(page)}
          defaultPage={Number(defaultPage)}
          rowsPerPage={Number(rowsPerPage)}
          count={Number(count)}
          onChangePage={onChangePage}
          onChangeRowsPerPage={onChangeRowsPerPage}
          onQuickJumper={onQuickJumper}
        />
      </Stack>
    </Stack>
  )
};
SimBasicList.propTypes = {
  variant: PropTypes.oneOf(['primary', 'secondary', 'tertiary', 'quaternary', 'alcohol', 'carbon', 'download', 'notification', 'feedback']),
  list: PropTypes.array,
  total: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  page: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  rowsPerPage: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  count: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  onChangePage: PropTypes.func,
  onChangeRowsPerPage: PropTypes.func,
  limit: PropTypes.number,

  onClick: PropTypes.func,
  loading: PropTypes.bool,
};

export default SimBasicList
